import React from "react"
import {  isSelected, modules, panels, isChecked, hotels, hotel_has_panel } from "../config/Helpers";
import axios from "axios";
import { Icon, Avatar, Menu, Dropdown, Badge } from 'antd';
import { HashLink as Link } from 'react-router-hash-link';
import Helmet from 'react-helmet'
import { latest as API_URL } from "../config/api";

const postUrlWidgets = API_URL + "notifications";

class Header extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      current_hotel    : { key  : "Locations", value : "all" },
      current_module   : { text : "REVENUE INTELLIGENCE", icon: "icon-marketing-active", value : 1 },
      //current_panel    : { text : "LEAD TIME" , icon: "icon-leadtime-active", value : "lead-time" },
      current_panel    : { _name : "FLASH SUMMARY" , _icon: "icon-summary-active", _value : "review" },
      module_menu_show : "hide-panel",
      panel_menu_show  : "hide-panel",
      hotel_menu_show  : "hide-panel",
      active_hotels    : {},
      request_status : "hide",
      request_cancel : null,
      count_notifications : 0,
      panels : panels(),
      hotels : hotels()
    };
    this.handleClickMenuItem = this.handleClickMenuItem.bind(this)
  }
  setDefaultValues(){
    this.setState({
      current_hotel    : { key  : "Locations", value : "all" },
      current_module   : { text : "REVENUE INTELLIGENCE", icon: "icon-marketing-active", value : 1 },
      //current_panel    : { text : "LEAD TIME" , icon: "icon-leadtime-active", value : "lead-time" },
      current_panel    : { _name : "FLASH SUMMARY" , _icon: "icon-summary-active", _value : "review" },
      module_menu_show : "hide-panel",
      panel_menu_show  : "hide-panel",
      hotel_menu_show  : "hide-panel",
      active_hotels    : {},
      request_status : "hide",
      request_cancel : null
    })
  }
  handleClickMenu(name) {
    if(this.state.request_status === "hide"){
      this.props.hideSelects();
      switch (name) {
        case "module_menu_show":
          this.state.module_menu_show === "hide-panel" ? this.setState({ module_menu_show : "" }) : this.setState({ module_menu_show : "hide-panel" });
        break;
        case "panel_menu_show":
          this.state.panel_menu_show === "hide-panel" ? this.setState({ panel_menu_show : "" }) : this.setState({ panel_menu_show : "hide-panel" });
        break;
        case "hotel_menu_show":
          this.setState({ 
            hotel_menu_show : this.state.hotel_menu_show === "hide-panel" ? "" : "hide-panel",
            active_hotels : Object.assign({}, this.props.current_filter_properties)
          });
          break;
        case "apply-hotels":
          this.setState({
            hotel_menu_show : this.state.hotel_menu_show === "hide-panel" ? "" : "hide-panel"
          }, function(){
            this.props.setFilterBubble(null, this.state.active_hotels, null, "property")
          })
        break;
      }
    }
  }
  componentDidMount(){
    setInterval(() => {
      this.setCountNotifications();
    }, 60000);
  }

  setCountNotifications(){
    return;
    if(this.props.app.state.is_login === false){ return; }
    let qs = require("qs"), self = this;
    axios({
        method : "POST",
        headers: { 'content-type' : 'application/x-www-form-urlencoded' },
        url : postUrlWidgets + "/count", 
        data : qs.stringify({ 
            api_token : localStorage.getItem('api_token')
        })
        
    }).then(function (response) {
        self.setState({
          count_notifications : response.data
        })
    });
  }
  componentWillReceiveProps(){
    this.setCountNotifications();
  }
  handleClickMenuItem(item, menu, _params_module = {}) {

    const CancelToken = axios.CancelToken;
    let request_cancel = CancelToken.source();

    switch (menu) {
      case "menu_hotel":
        let array_elements  = this.props.current_filter_properties
        
        if(array_elements[item.value] === undefined)
        {
          this.props.setFilterBubble(item.text, item.value, "hide", "property")
        }
        break;
      case "menu_module":
        if(item.value === 1){
          this.setState({current_module : { text : item.text, icon: item.icon, value : item.value } })
        }
      break;
      case "menu_panel":
        if (item._value === 'review' || item._value === 'reservation' || item._value === 'lead-time' || item._value === 'occupancy') {
          if(this.state.current_panel._name !== item._name){
            this.props.setTypePanel(item._value, _params_module)
            this.setState({current_panel : { _name : item._name, _icon: item._icon, _value : item._value } })
          }
        }
      break;
    }
  } 
  handleLogout(event) {
    localStorage.removeItem("api_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("pickup_years")
    window.location.reload();
    this.props.setSession(false)
  }

  addHotel(hotel){
    let active_hotels = this.state.active_hotels;
    if(active_hotels[hotel.value] === undefined){
      active_hotels[hotel.value] = hotel;
    }else{
      delete active_hotels[hotel.value];
    }
    this.setState({
      active_hotels : active_hotels
    })
  }
  render(){
    let self = this;
    
    let hotels = this.state.hotels;
    const listHotels = Object.keys(hotels).map((key, index) => {
    const disabled = (hotel_has_panel(hotels[key].hotel_id, self.state.current_panel._value) ===  false) ? true : false;
    const action = (hotel_has_panel(hotels[key].hotel_id, self.state.current_panel._value) ===  true) ? 
      { onClick : this.addHotel.bind(this, {'value' : hotels[key].hotel_id, "hotel" : hotels[key].hotel_name}) } : {};

        return (<li className={(disabled === true) ? "disabled" : "" }  key={"list-hotel-"+index} {...action}>
            <span children={hotels[key].hotel_name} />
            <input type="checkbox" 
              value={ hotels[key].hotel_id}
              disabled={disabled}
              checked={isChecked(this.state.active_hotels, hotels[key].hotel_id)} 
            />
            <span className="checkmark"></span>
        </li>);
    });

    const listModules = modules.map((item, index) => {
      let enabled = "";
      if (item.value !== 1){
        enabled = "disabled"
      }
      return (<li key={"list-module-" + index} className={"icon-grouppanel " + isSelected(item.value, this.state.current_module.value) + " " + enabled }
      onClick={this.handleClickMenuItem.bind(this, { text: item.text, icon: item.icon + "-active", value: item.value }, "menu_module")}>
        <span className={item.icon}></span>
        <span>{item.text}</span>
      </li>)
    });
    let _index = 0;
    const panels = this.state.panels
    const listPanels = Object.keys(panels).map((item, index) =>{
      let enabled = "";
      if ( panels[item].value === 'parity' || panels[item].value === 'website' || panels[item].value === 'demographic' || panels[item].value === 'panel-gallery') {
        return;
      }
      if(self.props.app.state.mode_report.status === true && self.props.app.state.mode_report._is_share === true){
        let panel_include = false, 
        panel_dashboards = self.props.app.state.mode_report._dashboards_select,
        _params_module = {} ;
        Object.keys(panel_dashboards).map((key, index) => {
          let _decode = JSON.parse(panel_dashboards[key])
          
          if(_decode._panel === panels[item].value){
            panel_include = true
            _params_module = _decode._params_module
          }
        })
        if(panel_include === true){
          if(self.props.app.state.panel !== this.state.current_panel._value && _index === 0){
            this.state.current_panel = { _name: panels[item].name, _icon: panels[item].icon + "-active", _value: panels[item].value }
            _index++;
          }
          return (<li key={"list-panel-" + index} className={"icon-grouppanel " + isSelected(panels[item].value, this.state.current_panel._value ) + " " + enabled }
          onClick={this.handleClickMenuItem.bind(this, { _name: panels[item].name, _icon: panels[item].icon + "-active", _value: panels[item].value }, "menu_panel", _params_module)}>
            <span className={panels[item].icon}></span>
            <span>{panels[item].name}</span>
          </li>)
        }

      }else{
        let panel_dashboards = panels[item].dashboards,
        default_dashboard = 0,
        _params_module = {}; 

        Object.keys(panel_dashboards).map((key, index) => {
          //No es necesario aplicar el JSON.parse
          let _decode = panel_dashboards[key]
          if(default_dashboard === 0){
            _params_module = _decode._params_module
            default_dashboard++
          }
        })

        return (<li key={"list-panel-" + index} className={"icon-grouppanel " + isSelected(panels[item].value, this.state.current_panel._value ) + " " + enabled }
      onClick={this.handleClickMenuItem.bind(this, { _name: panels[item].name, _icon: panels[item].icon + "-active", _value: panels[item].value }, "menu_panel", _params_module)}>
        <span className={panels[item].icon}></span> 
        <span>{panels[item].name.toUpperCase()}</span>
      </li>)
      }
      
    });
    
    const MenuItemGroup = Menu.ItemGroup;
    const menu = (
      <Menu
        mode="inline" style={{ width: 256 }}>
          <Menu.Item key="1">
            <span style={{fontSize : 11, letterSpacing : 1}}>
              <Icon type="user" style={{marginRight : 3}}/>{localStorage.getItem('email')}
            </span>
          </Menu.Item>
          <Menu.Divider />
          {/*<Menu.Item key="0" onClick={this.handleLogout.bind(this)}>
            <Link to="/setup">
              <span style={{fontSize : 11, letterSpacing : 1}}><Icon type="setting" style={{marginRight : 3}} /> ACCOUNT SETTINGS</span>
            </Link>
          </Menu.Item>*/}
          <Menu.Item key="0" onClick={this.handleLogout.bind(this)}>
            <span style={{fontSize : 11, letterSpacing : 1}}><Icon type="poweroff" style={{marginRight : 3}} /> LOGOUT</span>
          </Menu.Item>
      </Menu>
    );

    if(this.props.app.isInvitedUser()){
      return(
        <header id="main-header">
          <nav>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <Link to="/"><span className="logo-header"> </span></Link>
                </div>
                <div className="col-md-3 hotel-filter">
                  <div className={"request-load " + this.state.request_status}>
                    <Icon type="sync" spin />
                  </div>
                  <div className={"select-style " + this.state.hotel_menu_show}>
                    <span className="white">
                      <span onClick={this.handleClickMenu.bind(this, "hotel_menu_show")}>{this.state.current_hotel.key}</span>
                      <ul>
                        {listHotels}
                        <li onClick={this.handleClickMenu.bind(this, "apply-hotels")} className="btn-apply-hotels">APPLY</li>
                      </ul>
                    </span>
                  </div>
                </div>
                <div className="col-md-2 segment-filter" onClick={this.handleClickMenu.bind(this, "module_menu_show")}>
                  <div className={"request-load " + this.state.request_status}>
                    <Icon type="sync" spin />
                  </div>
                  <span className="invert-title">MODULE</span>
                  <div className="custom-select icon-component">
                    <span className={this.state.current_module.icon}></span>
                    <span className={"for-select " + this.state.module_menu_show}>{this.state.current_module.text}</span>
                  </div>
                    <div className={"group-panel " + this.state.module_menu_show}>
                      <ul>
                        {listModules}
                      </ul>
                    </div>
                </div>
                <div className="col-md-3 segment-filter" onClick={this.handleClickMenu.bind(this, "panel_menu_show")}>
                  <div className={"request-load " + this.state.request_status}>
                    <Icon type="sync" spin />
                  </div>
                  <span className="invert-title">PANEL</span>
                  <div className="custom-select icon-component">
                    <span className={this.state.current_panel._icon}></span>
                    <span className={"for-select " + this.state.panel_menu_show}>{this.state.current_panel._name.toUpperCase()}</span>
                  </div>
                  <div  className={"group-panel " + this.state.panel_menu_show}>
                    <ul>
                      {listPanels}
                    </ul>
                  </div>
                </div>
                <div className="col-md-1" style={{margin : 0, lineHeight : '70px'}}>
                  <div className="row">
                    <div className="col-md-6">
                      <Badge count={self.state.count_notifications}>
                        <Avatar 
                          style={{ backgroundColor: '#36a9e1' }}
                          shape="circle" icon="bell"
                          size={'large'}
                          onClick={() => {
                            this.props.app.setState({
                              notifications_window : true
                            })
                          }} />
                      </Badge>
                    </div>
                    {/*<div className="col-md-4">
                      <Badge>
                        <Avatar 
                          style={{ backgroundColor: '#36a9e1' }}
                          shape="circle" icon="read"
                          size={'large'}
                          onClick={() => {
                            this.props.app.setState({
                              news_window : true
                            })
                          }} />
                      </Badge>
                    </div> */}
                    <div className="col-md-6">
                      <Dropdown className="dropdown-options" overlay={menu} trigger={['click']}>
                          <Avatar style={{ backgroundColor: '#084b9a' }} icon="user" />
                      </Dropdown>
                    </div>
                </div>
                <Helmet>
                  <style>{`
                    .dropdown-options .anticon.anticon-user{
                        font-size : 18px !important;
                        line-height : 22px;
                        display : inline-block;
                    }
                    .ant-dropdown-menu-item-group-list{
                      list-style : none;
                    }
                    `}</style>
                </Helmet>
                </div>
              </div>
            </div>
          </nav>
        </header>
      )
    }else{
      return (<div></div>)
    }
  }
};

export default Header


// WEBPACK FOOTER //
// ./src/Frontend/components/Header.js